import {useCallback, useState} from "react";

export interface UseLeaderboardCardModalResult {
	open: boolean;
	openModal: () => void;
	closeModal: () => void;
}

export function useLeaderboardCardModal(): UseLeaderboardCardModalResult {
	const [open, setOpen] = useState(false);

	const openModal = useCallback(() => {
		setOpen(true);
	}, []);

	const closeModal = useCallback(() => {
		setOpen(false);
	}, []);

	return {open, openModal, closeModal};
}
